import React, {Component} from 'react'
import PropTypes from 'prop-types'
import './style.css'

class NRTHTML extends Component {

    render() {

        const {
            title,
            htmlContent,
        } = this.props

        return (
            <div className='html-content-container'>


                <div className="content"
                     dangerouslySetInnerHTML={{__html: htmlContent}}>
                </div>

            </div>
        )
    }
}


NRTHTML.propTypes = {
    title: PropTypes.string,
    htmlContent: PropTypes.string.isRequired,
}

NRTHTML.defaultProps = {}

export default NRTHTML



// WEBPACK FOOTER //
// ./src/components/_ead/_contentTypes/HTML/index.js